import { render, staticRenderFns } from "./BasePageFields.vue?vue&type=template&id=3c7aa61a&"
import script from "./BasePageFields.vue?vue&type=script&lang=js&"
export * from "./BasePageFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports